import React from 'react';
import PropTypes from 'prop-types';
import Nouislider from 'nouislider-react';

class MonthsSlider extends React.PureComponent {
  constructor(props) {
    super(props);

    const { initialMonths, minMonths, maxMonths } = this.props;

    this.state = {
      currentMonths: initialMonths || minMonths,
      range: {
        min: minMonths,
        max: maxMonths,
      },
    };
  }

  formatPrice = price => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  generateRentToOwnUrl = () => {
    const { adId, rentToOwnRentPrice, price } = this.props;
    const { currentMonths } = this.state;

    const baseUrl = '/rent_to_own_form';
    const params = new URLSearchParams();

    if (adId) params.append('id', adId);
    if (rentToOwnRentPrice)
      params.append('rent_to_own_rent_price', rentToOwnRentPrice);
    params.append('rent_for_months', currentMonths);
    params.append('price', price);

    return `${baseUrl}?${params.toString()}`;
  };

  handleSliderUpdate = values => {
    const months = Math.round(values[0]);
    this.setState({ currentMonths: months });
  };

  handleSliderSet = values => {
    const months = Math.round(values[0]);
    const { onMonthsChange } = this.props;

    if (onMonthsChange) {
      onMonthsChange(months);
    }
  };

  render() {
    const { currentMonths, range } = this.state;
    const { rentToOwnRentPrice } = this.props;

    return (
      <div className="filter-row">
        <div className="months-display-box">{currentMonths} месяцев</div>
        <div className="filter-range-slider">
          <Nouislider
            id="months_slider"
            key="months_slider"
            className="filter-range-slider-ui-comission"
            connect={[true, false]}
            range={range}
            start={[currentMonths]}
            step={1}
            onSlide={this.handleSliderUpdate}
            onSet={this.handleSliderSet}
          />
        </div>
        <React.Fragment>
          <div className="Offer__panelPrice">
            <div className="Offer__price">
              {this.formatPrice(rentToOwnRentPrice)}
              <span className="Offer__pricePeriod"> ₽/мес</span>
            </div>
            <div className="Offer__panelActions">
              <a
                id="ad_contacts_button"
                className="button button-large button-viewing button-orange"
                href={this.generateRentToOwnUrl()}
              >
                Снять перед покупкой
              </a>
            </div>
          </div>
        </React.Fragment>
      </div>
    );
  }
}

MonthsSlider.propTypes = {
  adId: PropTypes.string,
  initialMonths: PropTypes.number,
  maxMonths: PropTypes.number,
  minMonths: PropTypes.number,
  price: PropTypes.number,
  rentToOwnRentPrice: PropTypes.number,
  onMonthsChange: PropTypes.func,
};

MonthsSlider.defaultProps = {
  initialMonths: 3,
  minMonths: 3,
  maxMonths: 36,
  rentToOwnRentPrice: 0,
};

export default MonthsSlider;